import { apiClient } from "@apis/apiClient";

const feature = "geolayer";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  getByOrgCheckVisibility(params: any) {
    return apiClient.get(`/rest/${feature}/visibility`, { params: params });
  },

  getGeolayerById(id: any) {
    return apiClient.get(`/rest/${feature}/${id}`);
  },

  createGeolayer(params: any) {
    return apiClient.post(`/rest/${feature}/`, params, {
      headers: { "content-type": "application/json" },
    });
  },

  updateGeolayer(id: any, params: any) {
    return apiClient.put(`/rest/${feature}/${id}`, params, {
      headers: { "content-type": "application/json" },
    });
  },

  delete(id: any) {
    return apiClient.delete(`/rest/${feature}/${id}`);
  },
};
